export default __webpack_public_path__ + "static/data-about-screenshot-2-ea1e9ced52340c22a91d4742e16ab176.png";